// extracted by mini-css-extract-plugin
export default {"link":"BO-z","disabled":"CO-z"};